import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  'selectedRadio': '',
  'selectedValidityDays': '',
  'formatedValidityDate': '',
  'selectedFilters': [],
  'categories': [],
  'offset': 0,
};

export const contentFilterSlice = createSlice({
  name: 'contentFilter',
  initialState,
  reducers: {
    setContentFilterData: (state, action) => {
      for (let x in action.payload) {
        if (x in state) {
          state[x] = action.payload[x];
        }
      }
    },
    resetContentFilterData: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setContentFilterData, resetContentFilterData } = contentFilterSlice.actions;

export default contentFilterSlice.reducer;